<template>
	<section id="portfolio" class="portfolio-area">
		<div class="container">
			<div class="col-12 about-content-header text-center my-3">
				<span class="water-text">Projects</span>
				<h2 class="page-section-heading text-center mb-0">Projects</h2>
				<div class="divider-custom">
					<div class="divider-custom-line" />
					<div class="divider-custom-icon">
						<i class="fas fa-star" />
					</div>
					<div class="divider-custom-line" />
				</div>
			</div>
			<div class="row port cs-style-3">
				<div v-view="inProject" class="col-12 col-md-6 col-lg-4 item-space">
					<figure>
						<img src="images/img/scms1.png" alt="img04" />
						<figcaption>
							<!--                            <h3>School College Management System</h3>-->
							<!--                            <span>May 2020</span>-->
							<a
								class="button modal_img"
								data-toggle="modal"
								data-target=".scms"
								data-work-name="Scms"
								data-img="images/img/scms1.png"
								>School College Management System</a
							>
						</figcaption>
					</figure>
				</div>
				<div class="col-12 col-md-6 col-lg-4 item-space">
					<figure>
						<img src="images/img/hrms.png" alt="img01" />
						<figcaption>
							<!--                            <h3>Camera</h3>-->
							<!--                            <span>May 2020</span>-->
							<a
								class="button modal_img"
								data-toggle="modal"
								data-target=".hrm"
								data-work-name="Camera"
								data-img="images/img/hrms.png"
								>HRM & Payroll</a
							>
						</figcaption>
					</figure>
				</div>
				<div class="col-12 col-md-6 col-lg-4 item-space">
					<figure>
						<img src="images/img/pos-pro.png" alt="img02" />
						<figcaption>
							<!--                            <h3>Music</h3>-->
							<!--                            <span>May 2020</span>-->
							<a
								class="button modal_img"
								data-toggle="modal"
								data-target=".pos"
								data-work-name="Music"
								data-img="images/img/pos-pro.png"
								>Inventory & Sales</a
							>
						</figcaption>
					</figure>
				</div>
				<div class="col-12 col-md-6 col-lg-4 item-space">
					<figure>
						<img src="images/img/portfolio-5.png" alt="img04" />
						<figcaption>
							<!--                            <h3>Settings</h3>-->
							<!--                            <span>May 2020</span>-->
							<a
								class="button modal_img"
								data-toggle="modal"
								data-target=".laravue"
								data-work-name="Settings"
								data-img="images/img/portfolio-5.png"
								>Laravue SPA User Management System</a
							>
						</figcaption>
					</figure>
				</div>
				<div class="col-12 col-md-6 col-lg-4 item-space">
					<figure>
						<img src="images/img/portfolio-4.jpg" alt="img01" />
						<figcaption>
							<!--                            <h3>Camera</h3>-->
							<!--                            <span>May 2020</span>-->
							<a
								class="button modal_img"
								data-toggle="modal"
								data-target=".groupd97"
								data-work-name="Camera"
								data-img="images/img/portfolio-4.jpg"
								>Event Management System</a
							>
						</figcaption>
					</figure>
				</div>
				<div class="col-12 col-md-6 col-lg-4 item-space">
					<figure>
						<img src="images/img//portfolio-1.png" alt="img02" />
						<figcaption>
							<!--                            <h3>Music</h3>-->
							<!--                            <span>May 2020</span>-->
							<a
								class="button modal_img"
								data-toggle="modal"
								data-target=".epayra"
								data-work-name="Music"
								data-img="images/img/portfolio-1.png"
								>Epayra Pharmacy Ecommerce & POS</a
							>
						</figcaption>
					</figure>
				</div>
				<!--                <div class="col-xl-12">-->
				<!--                    <div class="btn-center" id="skill"><a href="#skill" class="big button">Discover More</a></div>-->
				<!--                </div>-->
			</div>
		</div>
		<!-- modal Start -->
		<div
			class="modal fade scms"
			tabindex="-1"
			role="dialog"
			aria-labelledby="myLargeModalLabel"
			aria-hidden="true"
		>
			<div class="modal-dialog modal-xl">
				<div class="modal-content">
					<div class="modal-header">
						<h5 id="exampleModalLongTitle" class="modal-title">
							School College Management System
						</h5>
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body py-lg-5">
						<div class="container">
							<div class="row">
								<div class="col-12 col-lg-7">
									<div class="left_modal mb-4 mb-lg-0">
										<div class="left_modal_body d-flex justify-content-center">
											<img src="images/img/dzs-pro.png" alt="img01" />
											<!--                                            <img id="scms_img"/>-->
										</div>
									</div>
									<div class="right_modal_body_date mt-3">
										<h6 class="modal_work_name">
											Link:
											<a href="https://www.dinajpurzillaschool.edu.bd/"
												>Dinajpur Zilla School</a
											>
										</h6>
										<h6 class="modal_work_name">Technologies:</h6>
										<ul class="inline_flex_order">
											<li>CakePhp</li>
											<li>Croogo CMS</li>
											<li>Javascript & JQuery</li>
										</ul>
									</div>
								</div>
								<div class="col-12 col-lg-5">
									<div class="right_modal">
										<div class="right_modal_body">
											<div
												class="right_modal_body_des mb-2 mb-lg-4 justify-content-center"
											>
												A complete package of school college management system
												for educational institutions which is easily accessible
												and highly featured.
												<ul>
													<li>Student/Teacher/Parent panel</li>
													<li>Role base user access and permission</li>
													<li>Daily attendance with monthly report</li>
													<li>Online payment and admission</li>
													<li>
														Result/Merit/Tabulation sheet generator with
														Promotion
													</li>
													<li>Certificate/Testimonial/admit card generator</li>
													<li>Accounts management</li>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div
			class="modal fade hrm"
			tabindex="-1"
			role="dialog"
			aria-labelledby="myLargeModalLabel"
			aria-hidden="true"
		>
			<div class="modal-dialog modal-xl">
				<div class="modal-content">
					<div class="modal-header">
						<h5 id="exampleModalLongTitle" class="modal-title">
							Human Resource Management System
						</h5>
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body py-lg-5">
						<div class="container">
							<div class="row">
								<div class="col-12 col-lg-7">
									<div class="left_modal mb-4 mb-lg-0">
										<div class="left_modal_body d-flex justify-content-center">
											<img id="hrm_img" />
										</div>
									</div>

									<div class="right_modal_body_date mt-3">
										<h6 class="modal_work_name">
											Link:
											<a href="https://dev.techplexus.com.bd/hrm/">Demo HRM</a>
										</h6>
										<h6 class="modal_work_name">Technologies:</h6>
										<ul class="inline_flex_order">
											<li>CodeIgniter</li>
											<li>Bootstrap</li>
											<li>Javascript & JQuery</li>
											<li>AJAX</li>
										</ul>
									</div>
								</div>
								<div class="col-12 col-lg-5">
									<div class="right_modal">
										<div class="right_modal_body">
											<div
												class="right_modal_body_des mb-2 mb-lg-4 justify-content-center"
											>
												An exclusive HRM web application enriched with
												attractive design and fully automated user friendly
												workforce with lots of customization and improved
												features to maintain large organizations.
												<ul>
													<li>Managing payroll with bonus calculation</li>
													<li>Employee self-service with employee portal</li>
													<li>Daily attendance with device integration</li>
													<li>Leave, Event & Holiday management</li>
													<li>Project & task management</li>
													<li>
														Scheduled invoice generator and email invoice to
														clients.
													</li>
													<li>Asset management</li>
													<li>Balance sheet & customized detailed reports</li>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div
			class="modal fade pos"
			tabindex="-1"
			role="dialog"
			aria-labelledby="myLargeModalLabel"
			aria-hidden="true"
		>
			<div class="modal-dialog modal-xl">
				<div class="modal-content">
					<div class="modal-header">
						<h5 id="exampleModalLongTitle" class="modal-title">
							Point of sale & Inventory
						</h5>
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body py-lg-5">
						<div class="container">
							<div class="row">
								<div class="col-12 col-lg-7">
									<div class="left_modal mb-4 mb-lg-0">
										<div class="left_modal_body d-flex justify-content-center">
											<img id="pos_img" />
										</div>
									</div>
									<div class="right_modal_body_date mt-3">
										<h6 class="modal_work_name">
											Link:
											<a href="https://posplex.org/qvc/">QVC BD Ltd.</a>
										</h6>
										<h6 class="modal_work_name">Technologies:</h6>
										<ul class="inline_flex_order">
											<li>CodeIgniter</li>
											<li>Bootstrap</li>
											<li>Javascript & JQuery</li>
										</ul>
									</div>
								</div>
								<div class="col-12 col-lg-5">
									<div class="right_modal">
										<div class="right_modal_body">
											<div
												class="right_modal_body_des mb-2 mb-lg-4 justify-content-center"
											>
												An exclusive HRMS web application enriched with
												attractive design and fully automated user friendly
												workforce.
												<ul>
													<li>User Management with Role Based Permission.</li>
													<li>Accounting and Due calculation</li>
													<li>Product Code Management</li>
													<li>Product Ordering & Transfer</li>
													<li>Purchase & Sale automation</li>
													<li>Multiple Inventory system.</li>
													<li>Customized Account statement reports</li>
													<li>SMS integration</li>
													<li>Auto Renewal Service.</li>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div
			class="modal fade laravue"
			tabindex="-1"
			role="dialog"
			aria-labelledby="myLargeModalLabel"
			aria-hidden="true"
		>
			<div class="modal-dialog modal-xl">
				<div class="modal-content">
					<div class="modal-header">
						<h5 id="exampleModalLongTitle" class="modal-title">
							Laravue SPA User Role Management
						</h5>
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body py-lg-5">
						<div class="container">
							<div class="row">
								<div class="col-12 col-lg-7">
									<div class="left_modal mb-4 mb-lg-0">
										<div class="left_modal_body d-flex justify-content-center">
											<img id="laravue_img" />
										</div>
									</div>
									<div class="right_modal_body_date mt-3">
										<h6 class="modal_work_name">
											Link:
											<a href=""
												>Laravue SPA User Role Management git repository</a
											>
										</h6>
										<h6 class="modal_work_name">Technologies:</h6>
										<ul class="inline_flex_order">
											<li>Laravel</li>
											<li>Vue.js</li>
											<!--                                            <li>Javascript & JQuery</li>-->
										</ul>
									</div>
								</div>
								<div class="col-12 col-lg-5">
									<div class="right_modal">
										<div class="right_modal_body">
											<div
												class="right_modal_body_des mb-2 mb-lg-4 justify-content-center"
											>
												A laravel user role management boilerplate with vue spa.
												<ul>
													<li>User Management with Role Based Permission.</li>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div
			class="modal fade groupd97"
			tabindex="-1"
			role="dialog"
			aria-labelledby="myLargeModalLabel"
			aria-hidden="true"
		>
			<div class="modal-dialog modal-xl">
				<div class="modal-content">
					<div class="modal-header">
						<h5 id="exampleModalLongTitle" class="modal-title">
							Event Management System
						</h5>
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body py-lg-5">
						<div class="container">
							<div class="row">
								<div class="col-12 col-lg-7">
									<div class="left_modal mb-4 mb-lg-0">
										<div class="left_modal_body d-flex justify-content-center">
											<img id="d97-img" />
										</div>
									</div>
									<div class="right_modal_body_date mt-3">
										<h6 class="modal_work_name">
											Link:
											<a href="http://groupd97.com/">groupd97</a>
										</h6>
										<h6 class="modal_work_name">Technologies:</h6>
										<ul class="inline_flex_order">
											<li>Bootstrap</li>
											<li>CakePhp</li>
											<li>Javascript & JQuery</li>
										</ul>
									</div>
								</div>
								<div class="col-12 col-lg-5">
									<div class="right_modal">
										<div class="right_modal_body">
											<div
												class="right_modal_body_des mb-2 mb-lg-4 justify-content-center"
											>
												Its a social development site for members participation
												in events and donations. Clients requirements was
												designing an attractive website for making a imaginative
												approach to the country. For having a good knowledge in
												bootstrap and jquery I have easily accomplished my goal.

												<ul>
													<li>User Management with Role Based Permission.</li>
													<li>Event Management.</li>
													<li>Donation Management.</li>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div
			class="modal fade epayra"
			tabindex="-1"
			role="dialog"
			aria-labelledby="myLargeModalLabel"
			aria-hidden="true"
		>
			<div class="modal-dialog modal-xl">
				<div class="modal-content">
					<div class="modal-header">
						<h5 id="exampleModalLongTitle" class="modal-title">
							Epayra Pharmacy Ecommerce & POS
						</h5>
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body py-lg-5">
						<div class="container">
							<div class="row">
								<div class="col-12 col-lg-7">
									<div class="left_modal mb-4 mb-lg-0">
										<div class="left_modal_body d-flex justify-content-center">
											<img id="epayra_img" />
										</div>
									</div>
									<div class="right_modal_body_date mt-3">
										<h6 class="modal_work_name">
											Link:
											<a href="https://epayra.com.bd/">Epayra</a>
										</h6>
										<h6 class="modal_work_name">Technologies:</h6>
										<ul class="">
											<li>Wordpress</li>
											<li>Woocommerce</li>
											<li>CodeIgniter</li>
											<li>Javascript & JQuery</li>
										</ul>
									</div>
								</div>
								<div class="col-12 col-lg-5">
									<div class="right_modal">
										<div class="right_modal_body">
											<div
												class="right_modal_body_des mb-2 mb-lg-4 justify-content-center"
											>
												Epayra is an online pharmacy built in wordpress with
												many customized plugins to resolve client's requirements
												integrated with POS application.

												<ul>
													<li>Agent base delivery system.</li>
													<li>
														SMS integration to send OTP message while
														registering new user .
													</li>
													<li>Customized checkout system.</li>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- modal End -->
	</section>
</template>

<script>
import $ from "jquery";
//Jquery For Bootstrap Modal
$(document).on("click", ".modal_img", function () {
	var imgsrc = $(this).data("img");
	var work_name = $(this).data("work-name");
	$("#my_image").attr("src", imgsrc);
	$("#scms_img").attr("src", imgsrc);
	$("#hrm_img").attr("src", imgsrc);
	$("#pos_img").attr("src", imgsrc);
	$("#laravue_img").attr("src", imgsrc);
	$("#epayra_img").attr("src", imgsrc);
	$("#d97-img").attr("src", imgsrc);
	$("#modal_work_name").text(work_name);
});
export default {
	methods: {
		inProject() {
			this.$emit("inProject");
		},
	},
};
</script>

<style scoped></style>
